import "./Technology.css";
import Footer from "./Footer";
import solimg8 from "../assets/sol-img8.png";
import solimg9 from "../assets/sol-img9.png";


export default function TechProcess() {
    return (
        <section id="tech-pro">
            {/* TOP SECTION */}
            <div className="technology-wrapper-a">
                {/* LEFT CONTENT */}
                <div className="technology-text-a">
                    <h3>Process</h3>
                    <h3>
                        Industry 4.0 – The Foundation of Our Cutting-Edge Manufacturing
                    </h3>

                    <p>
                        At SCL, process excellence is driven by advanced automation, intelligent control and continuous innovation. Our R&D and manufacturing teams apply Industry 4.0 principles – online monitoring, data analytics and precision engineering – to deliver consistent, high-quality aluminium castings. From concept to serial production, every process is designed for stability, repeatability and customer value.
                    </p>
                </div>
            </div>

            <h2 className="technology-title">Advanced Process Technologies</h2>
            <div className="tech-underline"></div>
            <p style={{ textAlign: "center", margin: "30px 220px" }}>Each of these innovations showcases our deep engineering expertise and commitment to precision manufacturing:</p>

            <div className="img-grid1a">
                <img src={solimg8} alt="solutions" />
                <img src={solimg9} alt="solutions" />
            </div>

            <div className="tech-wrapper">
                {/* CARD 1 */}
                <div className="tech-card">
                    <div className="tech-header">
                        AI-Driven X-Ray Inspection
                    </div>

                    <div className="tech-body">
                        <p>
                            Fully automated X-ray analysis uses AI-based image detection to identify casting defects in real time, ensuring zero-compromise quality across all batches.
                        </p>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="tech-card">
                    <div className="tech-header">
                        Compressor housing volute Surface refinement
                    </div>

                    <div className="tech-body">
                        <p>
                            Three grades available for Ra: (A-standard) 8μm-13μm (B-fine) 3μm-8μm (C-ultra fine)1μm-3μm using our patented abrasive flow process, achieving ultra-smooth surfaces for improving airflow efficiency and overall performance.
                        </p>
                    </div>
                </div>

                {/* CARD 3 */}
                <div className="tech-card">
                    <div className="tech-header">
                        HPDC with Steel Cores
                    </div>

                    <div className="tech-body">
                        <p>High-Pressure Die Casting with steel cores enables undercut profiles and complex internal features that are traditionally not feasible, increasing functional integration in a single part.</p>
                    </div>
                </div>
            </div>
            <div className="tech-wrapper">
                {/* CARD 1 */}
                <div className="tech-card">
                    <div className="tech-header">
                        Cast-in Fluid Channels
                    </div>

                    <div className="tech-body">
                        <p>
                            Cast-in pipes within HPDC components create integrated fluid channels, making additional machining obsolete, leading to cost reduction and enhancing thermal and fluid performance.
                        </p>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="tech-card">
                    <div className="tech-header">
                        Real-Time Process Monitoring
                    </div>

                    <div className="tech-body">
                        <p>Online control systems continuously track and adjust key die-casting parameters, maintaining stable shot profiles and consistent quality.</p>
                    </div>
                </div>
                

                {/* CARD 3 */}
                <div className="tech-card">
                    <div className="tech-header">
                        3D Printed Inserts
                    </div>

                    <div className="tech-body">
                        <p>
                            Complex inserts with conformal cooling optimise die temperature in critical zones, reducing cycle time and improving dimensional consistency.
                        </p>
                    </div>
                </div>
            </div>

            <div className="tech-wrapper-a">
                {/* CARD 1 */}
                <div className="tech-card">
                    <div className="tech-header">
                        Heat Treatment 
                    </div>

                    <div className="tech-body">
                        <p>
                            Specialised heat treatment routes for HPDC parts boost mechanical properties and durability, enabling aluminium to replace heavier materials in demanding applications.
                        </p>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="tech-card">
                    <div className="tech-header">
                        3-Plate Die Technology
                    </div>

                    <div className="tech-body">
                        <p>Realizing large, complex components to be cast with smaller die casting machines and improved cavity filling, delivering better quality at lower total cost.</p>
                    </div>
                </div>
            </div>

            <Footer />
        </section>
    );
}
